/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Harden_Detail6Inputs */

const en_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Package, privacy review, and store submission support.`)
};

const ar_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزم ومراجعة خصوصية ودعم تقديم المتجر.`)
};

const bn_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্যাকেজ, প্রাইভেসি রিভিউ ও স্টোর সাবমিশন সাপোর্ট।`)
};

const de_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketierung, Datenschutzprüfung und Unterstützung bei der Store-Einreichung.`)
};

const es_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empaquetar, revisión de privacidad y soporte para publicar en la tienda.`)
};

const fr_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packaging, revue de confidentialité et aide à la soumission sur le store.`)
};

const pt_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empacotar, revisão de privacidade e suporte para publicar na loja.`)
};

const zh_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打包、隐私审查和上架商店支持。`)
};

const tr_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketleyin, gizlilik incelemesi ve mağaza gönderim desteği.`)
};

const ru_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упакуйте, проверьте приватность и поддержите подачу в стор.`)
};

const pl_svc_browser_extensions_harden_detail6 = /** @type {(inputs: Svc_Browser_Extensions_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spakuj, sprawdź prywatność i wesprzyj wysyłkę do sklepu.`)
};

/**
* | output |
* | --- |
* | "Package, privacy review, and store submission support." |
*
* @param {Svc_Browser_Extensions_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_harden_detail6 = /** @type {((inputs?: Svc_Browser_Extensions_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_harden_detail6(inputs)
	if (locale === "de") return de_svc_browser_extensions_harden_detail6(inputs)
	if (locale === "es") return es_svc_browser_extensions_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_harden_detail6(inputs)
	return en_svc_browser_extensions_harden_detail6(inputs)
});
export { svc_browser_extensions_harden_detail6 as "svc_browser-extensions_HARDEN_detail" }